import React from "react";
import { Table, Skeleton } from "antd";
import Loader from "../loader/Loader";
import "./Table.css";
import CustomPagination from "../pagination/CustomPagination";
import {
  ArrowsAltOutlined,
  VerticalAlignMiddleOutlined,
} from "@ant-design/icons";
import expand from "../../../assets/Expand.svg"

const CommonTable = ({
  data,
  columns,
  style = {},
  settingModalDataFunction,
  showLoader,
  className,
  hover = false,
  skeletonRows = 10,
  tableTitle,
  rowClickable,
  pagination,
  onChange,
  expandable,
  rowExpandable,
  onExpand,
  expandedRowRender,
  expandIcon,
  serverSide = false,
  scroll = {},
  rowKey
}) => {

  const currentPage = pagination?.current || 1;
  const pageSize = pagination?.pageSize;

  const paginatedData = React.useMemo(() => {
    const source = data?.content || data || [];
    if (!pagination || serverSide) {
      return source;
    }
    const startIndex = (currentPage - 1) * pageSize;
    return source.slice(startIndex, startIndex + pageSize);
  }, [data, currentPage, pageSize, serverSide, pagination]);


  // Generate skeleton columns based on actual columns
  const getSkeletonColumns = () => {
    return columns.map((col) => ({
      ...col,
      render: () => <Skeleton.Input active size="small" style={{ width: '100%' }} />,
    }));
  };

  // Generate skeleton data rows
  const getSkeletonData = () => {
    return Array.from({ length: skeletonRows }, (_, index) => ({
      key: `skeleton-${index}`,
      id: `skeleton-${index}`,
    }));
  };

  

  const expandableConfig =
    expandable ||
    (expandedRowRender
      ? {
          expandedRowRender,
           expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <VerticalAlignMiddleOutlined
                onClick={(e) => onExpand(record, e)}
                style={{color: "var(--color-expandIcon-muted)", fontSize: "var(--font-size-4xl)",height:"var(--font-size-10xl)",weight:"var(--font-size-10xl)",borderRadius:"var( --radius-md)",padding:"5px",boxShadow: "0px 0px 6px 0px #0000001A"}}
              />
            ) : (
              <img src={expand} alt="expand-icon" onClick={(e) => onExpand(record, e)}  style={{color: "var(--color-expandIcon-muted)", fontSize: "var(--font-size-4xl)", height:"var(--font-size-10xl)",weight:"var(--font-size-10xl)",borderRadius:"var( --radius-md)",boxShadow: "0px 0px 6px 0px #0000001A"}}/>
            ),
          onExpand,
          rowExpandable,
        }
      : undefined);

  return (
    <>
      <div className={`common-table-card ${className || ""}`}>
        <div className="common-table-body">
          {showLoader ? (
            <div className="custom-table-wrapper table-responsive custom-scrollbar">
              <Table
                className={`custom-ant-table skeleton-table ${hover ? 'hover-effect' : 'no-hover-effect'}`}
                dataSource={getSkeletonData()}
                columns={getSkeletonColumns()}
                rowKey={(record) => record.key}
                pagination={false}
                scroll={scroll}
              />
            </div>
          ) : (
            <div className="custom-table-wrapper table-responsive custom-scrollbar">
              <Table
                className={`custom-ant-table ${hover ? 'hover-effect' : 'no-hover-effect'}`}
                dataSource={data?.content || data}
                columns={columns}
                rowKey={rowKey || ((record) => record.id || record.key || record.userId)}
                pagination={false}
                expandable={expandableConfig}
                scroll={scroll}
                onRow={(record) => ({
                  onClick: () =>
                    rowClickable &&
                    typeof settingModalDataFunction === "function"
                      ? settingModalDataFunction(record)
                      : null,
                })}
                rowClassName={() => (rowClickable ? "pointer-cursor" : "")}
                onChange={onChange}
              />
            </div>
          )}
        </div>
        {/* Custom Pagination */}
        {pagination && (Math.ceil(pagination.total / pagination.pageSize) > 1) && (
          <CustomPagination
            pagination={pagination}
            onPageChange={(page, size) =>
              onChange({ current: page, pageSize: size })
            }
          />
        )}
      </div>
    </>
  );
};

export default CommonTable;

